import api from "!../../../../../../../prodent-web/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../../prodent-web/node_modules/css-loader/dist/cjs.js??clonedRuleSet-23.use[1]!../../../../../../../prodent-web/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../../prodent-web/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-23.use[2]!../../../../../../../prodent-web/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-23.use[3]!../../../../../../../prodent-web/node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=style&index=0&id=60d20b5d&prod&lang=scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};